type Props = {
    children: React.ReactElement
    condition: boolean
    wrapper: (children: React.ReactElement) => React.ReactElement
}
export const Wrap: React.FC<Props> = ({ condition, wrapper, children }) =>
    condition ? wrapper(children) : children
